export default {
  login: {
    phonePlaceholder: 'Phone Number',
    captchaPlaceholder: 'Verification Code',
    getCaptcha: 'Get Code',
    captchaCountdown: '{seconds}s',
    captchaSent: 'Verification code sent',
    tabLogin: 'Sign In',
    tabRegister: 'Sign Up',
    registerAndLogin: 'Sign Up & In',
    fsRegisterLink: 'New users please register on FS',
    agreementPrefix: 'I have read and agree to the ',
    agreementAnd: ' and ',
    agreementIpePlatform:
      'User Agreement of the Ideological & Political Teaching Assistance System',
    agreementFsPlatform: 'Sasan Courseware Platform Agreement',
    agreementPrivacy: 'Privacy Policy',
    selectSubject: 'Select Subject',
    subjectModalTitle: 'Welcome to 33 Intelligent Learning Platform',
    subjectModalSubtitle: 'Please select a subject',
    slogan1: 'Knowledge Without Borders, Learning Without Limits',
    slogan2: 'Sasan Leads the Way to Shared Growth',
    slogan:
      'Knowledge Without Borders, Learning Without Limits. Sasan Leads the Way to Shared Growth',
    platformName: '33 Intelligent Learning Platform',
    orgName: 'Sasan Smart Education Technology',
    reportContact:
      'Report hotline for illegal and harmful information: ⁠15910773861 | Report email: bot@bj33smarter.com',
    reportNotice:
      'If you find any content that infringes your legitimate rights, please contact Beijing Sasan Smart Education Technology Co., Ltd. We will verify and handle it promptly.',
    companyInfo:
      'Technical support & operation: Beijing Sasan Smart Education Technology Co., Ltd.',
    error: {
      userNotExist:
        'This phone number is not registered yet. Please sign up first',
      phoneInvalid: 'Invalid phone number. Please check and try again',
      phoneExists:
        'This phone number is already registered. Please sign in directly',
      userDisabled:
        'This account has been disabled. Please contact the administrator',
      registerNotOpen:
        'Registration is not open yet. Please contact the administrator',
      registerRateLimited: 'Too many attempts. Please try again later',
      loginRateLimited: 'Too many sign-in attempts. Please try again later',
      platformNotBound:
        'This user is not bound to the platform. Please contact the administrator',
      captchaError:
        'The verification code is incorrect or expired. Please request a new one',
      smsCaptchaSent: 'Verification code already sent. Please try again later',
      smsUnavailable:
        'Verification code service is unavailable. Please try again later',
      smsDailyLimit:
        'Exceeded the maximum number of verification codes received per day',
      captchaSendFailed:
        'Failed to send verification code. Please try again later',
      operationFailed: 'Operation failed. Please try again later',
      phoneRequired: 'Please enter your phone number!',
      captchaRequired: 'Please enter the verification code!',
      agreementRequired: 'Please agree to the agreements!',
      subjectRequired: 'Please select a subject',
      subjectMissing: 'No subject selected, please sign in again',
    },
  },
  mainLayout: {
    platformName: '33 Intelligent Learning Platform',
    title: '33 Intelligent Learning Platform ({subject})',
    historySession: {
      history: 'History',
      favorites: 'Favorites',
      empty: 'No content yet',
      expiredWarning:
        'This conversation exceeds the 180-day retention limit and cannot be viewed or restored',
      unknownTypeError:
        'Cannot open this conversation: unknown conversation type "{type}"',
      favorite: 'Favorite',
      unfavorite: 'Unfavorite',
      favoriteSuccess: 'Added to favorites',
      favoriteFailed: 'Failed to add to favorites',
      unfavoriteSuccess: 'Removed from favorites',
      unfavoriteFailed: 'Failed to remove from favorites',
      rename: 'Rename',
      renameSuccess: 'Renamed successfully',
      renameFailed: 'Failed to rename',
      delete: 'Delete',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
      hasPptWarning:
        'This conversation contains generated PPTs and cannot be deleted',
      deleteConfirmTitle: 'Delete this conversation?',
      deleteConfirmContent:
        'After deletion, chat records in History and Favorites will be deleted together and cannot be recovered.',
      renameModalTitle: 'Edit Conversation Name',
      namePlaceholder: 'Enter a conversation name',
    },
    settings: 'Settings',
    logout: 'Sign Out',
    newChat: 'New Chat',
    comingSoon: 'Coming soon!',
    myTeachingResources: 'My Teaching Resources',
    myCoursewarePackage: 'My Courseware Packages',
    myCourseware: 'My Courseware',
    resourceSquare: 'Resource Square',
    agentMaterial: 'Smart Material Library',
    learningSpace: 'Learning Space',
    smartTools: 'Smart Tools',
    smartCourseware: 'Smart Courseware',
    myStudents: 'My Students',
    classroomCourseware: 'Classroom Courseware',
    smartCoursewarePackage: 'Smart Courseware Packages',
    smartCoursewarePackageComponent: 'Smart Courseware Package Components',
  },
  settings: {
    back: 'Back',
    navPersonal: 'Personal Info',
    navSchool: 'School Info',
    navAccount: 'Account',
    navOrders: 'My Orders',
    navAbout: 'About Us',
    accountTitle: 'Account Info',
    accountId: 'Account ID',
    phone: 'Phone Number',
    schoolId: 'School ID',
    schoolName: 'School Name',
    area: 'Region',
    personalTitle: 'Personal Info',
    name: 'Name',
    nameRule: 'Please enter a name (Chinese, letters and numbers)',
    gender: 'Gender',
    genderMale: 'Male',
    genderFemale: 'Female',
    pleaseSelect: 'Please select',
    areaTitle: 'Region',
    areaPlaceholder: 'Province-City-District/County',
    eduLevels: 'Preferred Education Levels',
    eduLevelsRequired: 'Please select preferred education levels',
    eduLevelsPlaceholder: 'Set education levels',
    updateProfile: 'Update Profile',
    updateSuccess: 'Updated successfully',
    ordersTitle: 'My Orders',
    packageName: 'Package',
    orderNo: 'Order No.',
    paidAt: 'Paid At',
    amount: 'Amount',
    status: 'Status',
    paid: 'Paid',
    action: 'Actions',
    billDetail: 'Bill Details',
    billTitle: 'Bill Details',
    channel: 'Payment Channel',
    paymentMethod: 'Payment Method',
    acquirer: 'Acquirer',
    channelTradeNo: 'Third-party Transaction No.',
    paymentNo: 'Payment No.',
    channelWechat: 'WeChat Pay',
    channelAlipay: 'Alipay',
    billLoadFailed: 'Failed to load bill. Please try again later',
    privacyPolicy: 'Privacy Policy',
    viewNow: 'View Now>',
  },
  cloudDisk: {
    overview: 'Overview',
    smartCourseware: 'Smart Courseware',
    projectFolder: 'Project Folders',
    unclassified: 'Unclassified',
    used: 'Used',
    capacityHint:
      ' (long-term valid, includes AI-generated smart courseware of all subjects, project folders and chat outputs)',
    name: 'Name',
    type: 'Type',
    updatedAt: 'Updated At',
    size: 'Size',
    action: 'Actions',
    ok: 'OK',
    cancel: 'Cancel',
    delete: 'Delete',
    preview: 'Preview',
    edit: 'Edit',
    download: 'Download',
    deleteSuccess: 'Deleted successfully',
    noFiles: 'No files yet',
    noFilesOfType: 'No files of this type',
    noResults: 'No matching files',
    allTypes: 'All Types',
    inputName: 'Enter a name',
    searchFilePlaceholder: 'Search file name',
    searchFolderOrFilePlaceholder: 'Search folder/file name',
    searchCoursewarePlaceholder: 'Search courseware name',
    typeDocument: 'Document',
    typeSpreadsheet: 'Spreadsheet',
    typePpt: 'PPT',
    typeHtml: 'HTML',
    typeMarkdown: 'Markdown',
    typeImage: 'Image',
    typeAudio: 'Audio',
    typeOther: 'Other',
    typePdf: 'PDF',
    typeVideo: 'Video',
    typeCourseware: 'Courseware',
    editInfoMissing: 'File editing info is missing',
    editNotSupported: 'This format does not support online editing',
    confirmDeleteFile: 'Delete this file?',
    deleteFileWarning: 'Once deleted, the file cannot be recovered.',
    deleteFileChatHint:
      'Click "Save to Cloud Drive" in the chat output to add the file again.',
    fileMissingDownload: 'File does not exist, unable to download',
    fileMissing: 'File does not exist',
    previewNotSupported: 'This format does not support preview',
    storageFullTitle: 'Cloud drive is full',
    storageFullContent: 'View only. Please clean up first',
    gotIt: 'Got it',
    downloadNotSupported: 'This format does not support download',
    coursewareName: 'Courseware Name',
    detailInfo: 'Details',
    updatedDate: 'Updated At',
    confirmDeleteCourseware: 'Delete this courseware?',
    deleteCoursewareWarning:
      'Once deleted, the courseware data will also be removed from the smart courseware list. Please proceed with caution.',
    currentVersion: 'Current Version',
    unnamed: 'Untitled',
    scaffold: 'Scaffold',
    dateFormat: 'MMM D, YYYY HH:mm',
    shortDateFormat: 'MMM D HH:mm',
    recentStorage: 'Recent Storage',
    viewAll: 'All →',
    noProjectFolders: 'No project folders yet',
    loading: 'Loading…',
    noStorageRecords: 'No storage records yet',
    unitFile: ' ',
    unitItem: ' ',
    statTotal: 'Smart Courseware + Chat Files',
    statCourseware: 'Smart Courseware',
    statProjectFolder: 'Project Folders ({count} files)',
    statUnclassified: 'Unclassified',
    confirmDeleteFolder: 'Delete this project folder?',
    deleteFolderWarning:
      'Once deleted, all files in the project folder will be removed. Please proceed with caution.',
  },
  ic: {
    creationLimit:
      'You have reached the courseware package limit. Please delete old packages before creating new ones',
    communityLimit:
      'You have reached the courseware limit. Please delete old courseware before proceeding',
    onlineCreate: 'Create Online',
    communityTitle: 'Resource Packages',
    communityGuide:
      'Click "Apply to Upload" in the courseware card options to submit a public package',
    communityEmpty: 'No public courseware yet',
    selectTextbook: 'Please select a textbook',
    gradeLabel: 'Grade: ',
    editionLabel: 'Edition: ',
    textbookLabel: 'Textbook: ',
    editionTextbook: 'Edition/Textbook',
    searchPlaceholder: 'Search courseware package name',
    myCourseware: 'My Courseware Packages',
  },
  fsPlayer: {
    backToEdit: 'Back to Editor',
  },
  coursewarePlayer: {
    digitalTutor: 'Digital Tutor',
    digitalCompanion: 'Digital Study Companion',
  },
  fsCourseware: {
    ok: 'OK',
    cancel: 'Cancel',
    delete: 'Delete',
    save: 'Save',
    preview: 'Preview',
    edit: 'Edit',
    upload: 'Upload',
    create: 'Create',
    choose: 'Select',
    restore: 'Restore',
    renameName: 'Rename',
    comingSoon: 'Coming soon',
    defaultModuleName: 'New Module {order}',
    defaultTagName: 'New Tag {order}',
    defaultLectureName: 'File',
    defaultTagFolderName: 'Tag Folder',
    defaultScaffoldName: 'Scaffold',
    defaultLectureDisplayName: 'File {count}',
    kindName: 'Name',
    kindCourseware: 'Courseware',
    kindModule: 'Module',
    kindTag: 'Tag',
    kindButton: 'Button',
    inputNameTitle: 'Enter a {kind} name',
    inputName: 'Enter a name',
    editNameTitle: 'Edit {kind} name',
    maxLengthExceeded: 'Up to {count} characters',
    addModule: 'Add module',
    addModuleAriaLabel: 'Add module',
    addTag: 'Add tag',
    addButton: 'Add button',
    deleteModuleTitle: 'Delete Module',
    confirmDeleteModule: 'Are you sure you want to delete this module?',
    deleteTagTitle: 'Delete Tag',
    confirmDeleteTag: 'Are you sure you want to delete this tag?',
    deleteLectureTitle: 'Delete File',
    confirmDeleteLecture: 'Are you sure you want to delete this file?',
    renameButtonName: 'Rename button',
    deleteButtonName: 'Delete button',
    replaceDisplayFile: 'Replace display file',
    removeDisplayFile: 'Remove display file',
    moreActions: 'More actions',
    confirmRemoveDisplayFile: 'Remove the display file?',
    removeDisplayFileWarning: 'Once removed, the file cannot be recovered.',
    removeSuccess: 'Removed successfully',
    removeFailed: 'Failed to remove. Please try again',
    confirmDeleteCourseware: 'Delete this courseware?',
    deleteCoursewareWarning:
      'Once deleted, it cannot be recovered. Please proceed with caution.',
    deleteSuccess: 'Deleted successfully',
    aiGenerate: 'AI Courseware',
    aiAnalysis: 'AI Analysis',
    versionManager: 'Version Manager',
    saveAsVersion: 'Save as Version',
    versionName: 'Version Name',
    versionNamePlaceholder: 'Enter a version name',
    saveVersionSuccess: 'Saved successfully!',
    saveVersionFailed: 'Failed to save version. Please try again',
    restoreSuccess: '"{name}" restored successfully!',
    restoreFailed: 'Failed to restore version. Please try again',
    restoreHint: 'Only the most recently saved manual version can be restored',
    fileModalCreateTitle: 'Create {name} content',
    fileModalUploadTitle: 'Upload {name} content',
    fileModalCreateFooter: 'Create File',
    fileModalUploadFooter: 'Upload File',
    fileNameLabel: 'File Name',
    fileNamePlaceholder: 'Enter a file name',
    pathLabel: 'Path',
    scaffoldLabel: 'Scaffold',
    uploadPlaceholderHint: 'Only PPT/PDF/HTML/MP4/WEBM, up to 200MB',
    h5LinkLabel: 'H5 Link',
    urlPlaceholder: 'Enter a URL',
    h5UrlInvalid: 'Enter a valid website starting with http:// or https://',
    emptyFileContent: 'No file content yet',
    dropToUpload: 'Release to upload the file',
    dragUploadHint:
      'Drag a local file here to upload, or use the buttons below to upload, create or select',
    uploading: 'Uploading, please wait...',
    uploadSuccess: 'Uploaded successfully',
    uploadFailed: 'Upload failed. Please try again',
    createFailed: 'Failed to create. Please try again',
    unsupportedFileType: 'Unsupported file type',
    unsupportedFileFormat: 'Unsupported file format',
    fileInfoInvalidReupload: 'Invalid file info. Please upload again',
    fileInfoInvalid: 'Invalid file info. Please try again',
    coursewareInfoInvalid: 'Invalid courseware info. Please try again',
    resourceCreateFailed: 'Failed to create resource. Please try again',
    unsupportedUploadType:
      'Only PPT, PDF, HTML, MP4 and WEBM files are supported',
    maxSizeExceeded: 'The file cannot exceed {size}MB',
    uploadUrlMissing: 'Upload URL is missing',
    uploadTokenFailed: 'Failed to get upload token',
    confirmRemoveScaffold: 'Remove this courseware?',
    removeScaffoldWarning: 'Once removed, the courseware cannot be recovered',
    scaffoldPanelTitle: '{name} Scaffolds',
    structureSyncFailed:
      'Failed to sync courseware structure. Please try again later',
    previewParamsMissing:
      'Preview parameters are missing. Please go back and try again.',
    previewOnlyMedia: 'Only audio and video preview is supported.',
    previewUrlFailed: 'Failed to get preview URL. Please try again later.',
    goBack: 'Go Back',
  },
  fsAgentMaterial: {
    tabCoursewareMaterial: 'Smart Courseware',
    tabAgentGeneratedMaterial: 'AI Generated Materials',
    searchPlaceholder: 'Search file names and content',
    fileName: 'File Name',
    detailInfo: 'Details',
    status: 'Status',
    action: 'Actions',
    preview: 'Preview',
    edit: 'Edit',
    download: 'Download',
    delete: 'Delete',
    inputName: 'Enter a name',
    stored: 'Stored',
    editInfoMissing: 'File editing info is missing',
    editNotSupported: 'This format does not support online editing',
    previewUrlFailed: 'Failed to get preview URL',
    confirmDeleteFile: 'Delete this file?',
    deleteFileWarning:
      'Note: This action cannot be undone and the file will no longer be downloadable',
    noResources: 'No resources yet',
    emptyDescription: 'No files yet. Start generating now',
    unnamed: 'Untitled',
    scaffold: 'Scaffold',
    coursewareName: 'Courseware Name',
    updatedDate: 'Updated At',
    type: {
      teachingPlanUnit: 'Large-Unit Teaching Design',
      teachingPlanLesson: 'Lesson Teaching Design',
      verbatimScript: 'Verbatim Script',
      homeworkPreview: 'Pre-class Preview',
      homeworkReview: 'Post-class Review',
      examQuiz: 'In-class Quiz',
      examUnit: 'Unit Test',
      examFinal: 'Semester Test',
      pblStudyPlan: 'PBL Project Design',
    },
  },
  learningSpace: {
    documentMaterial: 'Documents',
    coursewareMaterial: 'Sample Courseware',
    searchPlaceholder: 'Search file names and content',
    dateFormat: 'MMM D, YYYY',
    noResources: 'No resources yet',
    emptyDescription: 'Stay tuned for shares from other teachers',
    coursewareInfo: 'Courseware Info',
    fileInfo: 'File Info',
    updatedAt: 'Updated At',
    publisher: 'Publisher',
  },
  fsIntelligenceCourseware: {
    all: 'All',
    ok: 'OK',
    cancel: 'Cancel',
    onlineCreate: 'Create Online',
    searchPlaceholder: 'Search courseware name',
    courseware: 'Courseware',
    teachingTypeUnit: 'Large-Unit Teaching',
    teachingTypeSection: 'Classroom Teaching',
    teachingTypeUnclassified: 'Unclassified',
    createTitle: 'Create Smart Courseware',
    structureBlank: 'Blank Creation',
    structureSssdUnit: 'Sasan Large-Unit Structure Template',
    structureSssdCourse: 'Sasan Course Structure Template',
    createSubmit: 'Create Courseware',
    createSuccess: 'Created successfully',
    nameDuplicated: 'Courseware name already exists',
    unitStorageNotice:
      'All courseware can only be stored within a unit. If your courseware does not belong to the current unit, please close this page, switch the unit on the left and continue.',
    selectSubjectGrade: 'Select Subject & Grade',
    selectSubjectGradeRequired: 'Please select a subject and grade',
    subjectGradePlaceholder: 'Subject/Grade',
    coursewareUnitLabel: 'Courseware Unit',
    coursewareUnitRequired: 'Please select the courseware unit',
    structureLabel: 'Select Structure',
    structureRequired: 'Please select a structure',
    coverLabel: 'Cover',
    coverRequired: 'Please set a cover',
    nameLabel: 'Courseware Name',
    namePlaceholder: 'Enter a courseware name',
    uploadImage: 'Upload Image',
    changeUploadImage: 'Change Image',
    uploadImageHint: 'Only JPG/PNG/JPEG are supported, up to 2MB',
    uploading: 'Uploading',
    uploadingDots: 'Uploading...',
    materialCover: 'Material Cover',
    changeMaterialCover: 'Change Material Cover',
    selectTextbook: 'Select a textbook',
    stageLabel: 'Stage: ',
    subjectLabel: 'Subject: ',
    gradeLabel: 'Grade: ',
    editionLabel: 'Edition: ',
    textbookLabel: 'Volume: ',
    editionTextbook: 'Edition/Textbook',
    unitResourceTitle: 'Unit Resource Courseware',
    uploadGuide:
      'Click "Apply to Upload" in the courseware card options to submit public courseware',
    publicTypeLabel: 'Public Type: ',
    coursewareTypeLabel: 'Courseware Type: ',
    noPublicCourseware: 'No public courseware yet',
    scopeSchool: 'School Public',
    scopePlatform: 'Platform Public',
    myCoursewareNav: 'My Courseware',
    obtain: 'Get',
    moveTitle: 'Move to Current Unit',
    moveSuccess: 'Moved successfully',
    selectSectionPlaceholder: 'Select a lesson in the current unit',
    unitTab: 'Large-Unit',
    updatedDateLabel: 'Updated: ',
    creatorLabel: 'Creator: ',
    schoolLabel: 'School: ',
    createdByMe: 'Created by Me',
    officialCourseware: 'Official Courseware',
    detail: 'Details',
    uploadBlockPrefix: 'Please click ',
    uploadBlockMoveTo: 'Move to',
    uploadBlockMiddle: ' to categorize the courseware before ',
    uploadBlockApplyUpload: 'Apply to Upload',
    uploadBlockSuffix: ' to this unit resource courseware',
    loadingMore: 'Loading...',
    noMatchCourseware: 'No matching courseware',
  },
  contentTree: {
    ok: 'OK',
    cancel: 'Cancel',
    delete: 'Delete',
    save: 'Save',
    templateName: 'Template name',
    unknownError: 'Unknown error',
    missingCoursewareId: 'Missing courseware ID',
    getHermesTreeFailed: 'Failed to load Hermes tree data',
    nameLabel: 'Name: {name}',
    nodeType: {
      root: 'Root',
      rootShort: 'Root',
      module: 'Module',
      reference: 'Reference',
      slot: 'Slot',
      tag: 'Tag',
      transition: 'Transition',
    },
    deleteNodeTitle: 'Confirm Node Deletion',
    deleteNodeConfirm: 'Delete node "{name}"?',
    deleteNodeChildrenWarning:
      'This node has children. Deleting it will also delete all its children',
    executeConfirmTitle: 'Save & Execute',
    executeConfirmContent:
      'The system will create a version snapshot and automatically run AI to generate content for all slot nodes',
    executeConfirmOk: 'Confirm Execution',
    moduleSelectTitle: 'Select Modules to Generate',
    moduleSelectOk: 'Confirm Generation',
    moduleSelectAll: 'Select All',
    moduleSelectCount: 'Selected {selected} / {total}',
    moduleSelectSlotCount: '{count} slots',
    modals: {
      treeDescriptionTitle: 'Expand TREE Description',
      unsupportedFileFormat: 'This file format is not supported',
      fileTooLarge: 'File size cannot exceed {size}MB',
      maxFiles: 'Up to {count} files can be uploaded',
      duplicateFile:
        'A file with the same name already exists in the list. Please do not add it again',
      uploadSuccess: '{name} uploaded successfully',
      uploadFailed: 'Failed to upload {name}',
      seedRequired: 'Please enter the TREE description first',
      uploadingWait: 'Reference files are uploading. Please wait',
      subjectUnknown:
        'Unable to determine the subject of the current courseware',
      originName: 'Origin Name',
      originDescription: 'Origin Description',
      originDescriptionPlaceholder: 'Enter origin description...',
      seedLabel: 'TREE Description (Seed Text)',
      seedPlaceholder:
        'Describe the courseware content for AI to generate the outline structure...',
      referenceFiles: 'Reference Files (optional)',
      uploadHint: 'Click or drag to upload reference files',
      uploadFormats:
        'Supports PDF, Word, TXT and MD formats, up to 20MB, max 5 files',
      reopenHint: 'You can reopen it anytime via "AI Tree" at the bottom left',
      generating: 'AI generating...',
      generateStructure: 'Generate Structure with AI',
      loading: 'Loading...',
      generateFullStructure: 'Generate Full Structure',
    },
    editorTab: {
      design: 'TREE Design',
      review: 'Content Review',
      export: 'Convert & Export',
    },
    editor: {
      aiBuildTree: 'AI Tree',
      addRoot: '+Origin',
      addModule: '+Module',
      addTag: '+Tag',
      addSlot: '+Slot',
      addTransition: '+Transition',
      addReference: '+Reference',
      noTreeData: 'No content tree data',
      buildTreeFirst: 'Please generate the structure with AI Tree first',
      createModuleFirst: 'Please create a module first',
      versionSaved: 'Version saved',
      saveVersionFailed: 'Failed to save version',
      generateOrAddNodesFirst: 'Please generate or add nodes first',
      mdExported: 'MD document exported',
      exportMd: 'Export MD',
      outlineGeneratingPercent: 'Generating outline {percent}%',
      generateOutline: 'Generate Outline',
      saveVersion: 'Save Version',
      versionHistory: 'Version History',
      exportFileNamePrefix: 'ContentTree',
      treeCreated: 'Content tree created',
      defaultTreeName: 'New Content Tree',
      createFailed: 'Failed to create',
      back: 'Back',
      generateFirstHint:
        'Please click "Generate Outline" to generate content first',
      generatingHint: 'The content outline is being generated. Please wait',
      noTreeTitle: 'No content tree yet',
      noTreeSubtitle:
        'Click the button below to create a content tree for this courseware',
      createTree: 'Create Content Tree',
    },
    panel: {
      title: 'Node Details',
      selectNodeHint: 'Select a node to view details',
      nodeName: 'Node Name',
      showName: 'Backfill Name',
      showNamePlaceholder: 'Leave blank to use the node name',
      typeLabel: 'Type',
      promptTemplate: 'Prompt Template',
      promptTemplatePlaceholder: 'Enter prompt template...',
      nodeDescription: 'Node Description',
      descriptionPlaceholder: 'Enter description...',
      deleteNode: 'Delete Node',
      referenceFileList: 'Reference files',
      uploadFormatsDetail:
        'Supports PDF, Word, TXT and MD, up to 20MB each, max 5 files',
      saveFailedRetry: 'Save failed · Click to retry',
      editingStatus: 'Editing…',
      savingStatus: 'Saving…',
      savedStatus: '✓ Saved',
    },
    exportPage: {
      loadingData: 'Loading export data...',
      exportDone:
        'HTML export completed. You can download the results or backfill',
      exportTimeout: 'Export timed out',
      exportFailedDetail: 'Export failed: {message}',
      importTimeout: 'Import timed out',
      importDone: 'Import to courseware platform completed',
      importFailedDetail: 'Import failed: {message}',
      submittingExport: 'Submitting export task...',
      exportTaskStarted: 'Export task started',
      triggerExportFailed: 'Failed to trigger export',
      exportFirstHtml: 'Please export HTML for the selected slots first',
      downloadStarted: 'Export download started',
      downloadExportFailed: 'Failed to download export results',
      submittingImport: 'Submitting import task...',
      importTaskStarted: 'Import task started',
      triggerImportFailed: 'Failed to trigger import',
      promptSaved: 'Prompt saved',
      promptSaveFailed: 'Failed to save prompt',
      htmlLoadFailed: 'Failed to load HTML',
      previewHint: 'Click the eye icon of a generated slot to preview its HTML',
      htmlGenerating: 'Generating HTML...',
      importWaitExporting:
        'Export in progress. Wait for it to finish before backfilling',
      downloadWaitExporting: 'Export in progress. Please wait',
      generatingPercent: 'Generating {percent}%',
      generateHtml: 'Generate HTML',
      promptPlaceholderSelected:
        'Shows the style prompt of the selected slots. Edit and save...',
      promptPlaceholderEmpty: 'Select slots to export on the left first',
      promptPanelTitle: 'HTML Style Prompt',
      previewTitle: 'HTML Preview',
      enlargeHint: 'Select a slot with generated HTML first',
      enlarge: 'Enlarge',
      shrink: 'Shrink',
      downloading: 'Downloading...',
      exportHtml: 'Export HTML',
      importToPlatform: 'Backfill to Platform',
      importingPercent: 'Importing {percent}%',
      importing: 'Importing...',
      selectAllSlots: 'Select all ({selected}/{total} slots)',
      cancelPreview: 'Cancel preview',
      previewSlotHtml: 'Preview this slot HTML',
      htmlGenerated: 'HTML generated',
      generatingHtml: 'Generating HTML',
      htmlNotGenerated: 'HTML not generated',
      noContentPlaceholder: '> No generated content yet',
      contentPreviewTitle: 'Content Preview',
      selectedCount: '{count} slots selected',
      previewFirstOnly: ' · previewing the first',
      selectNodeHint: 'Select a node to export on the left',
    },
    review: {
      loadingData: 'Loading review data...',
      generatingPercent: 'Generating {percent}%',
      outlineEvaluation: 'Evaluate Outline',
      evaluationDisabledTip:
        'The outline is being generated. Evaluation will be available after completion',
      nextStep: 'Next',
      generatingContent: 'Generating content…',
      noTreeData: 'No tree data',
      generatingRemaining: 'Generating remaining content…',
      noContent: 'No generated content',
      nothingToCopy: 'Nothing to copy',
      copied: 'Copied to clipboard',
      copyFailed: 'Copy failed',
      copyMarkdown: 'Copy Markdown',
      copyMd: 'Copy MD',
      regenerateDone: 'Regeneration completed',
      regenerateFailed: 'Regeneration failed',
      hermesSaveFailed: 'Hermes save failed: {message}',
      savedHermesLocalSyncFailed: 'Saved to Hermes, but local sync failed',
      saveSuccess: 'Saved',
      saveFailed: 'Save failed',
      hermesUpdatedLocalPartialFailed:
        'Hermes updated, but some local syncs failed',
      selectNodeHint: 'Select a node on the left to view its content',
      viewPrompt: 'View input prompt',
      prompt: 'Prompt',
      editContent: 'Edit content',
      edit: 'Edit',
      regenerate: 'Regenerate',
      regenerateTitle: 'Regenerate Outline',
      regeneratePromptLabel:
        'Describe your changes to regenerate the outline based on the current content:',
      regeneratePromptPlaceholder:
        'E.g. add more interactive elements, simplify the language...',
      noPromptToCopy: 'No prompt to copy',
      promptDrawerTitle: '{name} · Input Prompt',
      copyPrompt: 'Copy prompt',
      copy: 'Copy',
      noPrompt: 'No prompt for this node',
    },
    store: {
      hermesTimeout: 'Hermes task timed out (4 hours)',
      outlineDone: 'Content outline generation completed',
      hermesGenerateFailed: 'Hermes courseware generation failed',
      reconnectFailed:
        'Network error. Multiple reconnection attempts failed. Please resubmit',
      submittingGeneration: 'Submitting generation task...',
      noPermission:
        'You do not have permission. Please contact the administrator',
      uploadFailedDetail: 'Upload failed: {detail}',
      taskIdMissing: 'No task ID returned',
      generationSubmitted: 'Content generation task submitted',
      uploadHermesFailed: 'Failed to upload to Hermes',
      resumingGeneration: 'Resuming generation task...',
      generationStopped: 'Generation stopped',
    },
    requests: {
      getTreeFailedHttp: 'Failed to get Hermes tree: HTTP {status}',
      getTreeFailed: 'Failed to get Hermes tree',
      updateOutlineFailedHttp: 'Failed to update outline: HTTP {status}',
      regenerateFailedDetail: 'Failed to regenerate outline: {detail}',
      regenerateFailed: 'Failed to regenerate outline',
      triggerExportFailedDetail: 'Failed to trigger export: {detail}',
      triggerExportFailed: 'Failed to trigger export',
      downloadFailedHttp: 'Failed to download export: HTTP {status}',
      defaultZipFileName: 'CoursewareExport_{taskId}',
      triggerImportFailedDetail: 'Failed to trigger import: {detail}',
      triggerImportFailed: 'Failed to trigger import',
      queryExportStatusFailedHttp:
        'Failed to query export status: HTTP {status}',
      queryImportStatusFailedHttp:
        'Failed to query import status: HTTP {status}',
      getHtmlFailedHttp: 'Failed to get HTML: HTTP {status}',
      getModelConfigFailedHttp: 'Failed to get model config: HTTP {status}',
      configureModelFirst:
        'Please configure a model on the Agent platform first',
    },
    canvas: {
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      fitView: 'Fit view',
      autoLayout: 'Auto layout',
    },
    templatePicker: {
      nameRequired: 'Please enter a name',
      renamed: 'Renamed',
      renameFailed: 'Failed to rename',
      deleted: 'Deleted',
      deleteFailed: 'Failed to delete',
      subjectOrGradeUnknown:
        'Unable to determine the subject or level of the current courseware',
      systemTemplateName: 'System subject template "{name}"',
      userTemplateName: 'Template "{name}"',
      displayName: '{name} ({creator})',
      creatorFallback: 'Another teacher',
      replaceConfirm:
        'This will clear the current content and replace it with {name}. Continue?',
      applySuccess: 'Full generation completed',
      applyFailed: 'Full generation failed. Please retry',
      applyTemplate: 'Apply Template',
      systemTemplateLabel: 'System subject template (default)',
      currentSubject: 'current subject',
      presetStructure: 'Preset structure of {name}',
      noDefaultPrompt: 'No default prompts yet. Please upload',
      mine: 'Mine',
      deleteConfirm: 'Delete this template?',
      noUserTemplates:
        'No user templates for this subject yet. The system default structure will be used',
      renameTitle: 'Rename Template',
    },
    uploadPrompts: {
      uploadButton: 'Upload Full Prompts',
      fileModalTitle: 'Prompt Files',
      uploadHint: 'Click or drag to upload prompt files',
      formatsHint: 'MD only, up to {size}MB, max {count} files',
      previewModalTitle: 'Preview: Upload Full Prompts',
      updateSuccess:
        'Updated subject template "{subject}": {slots} slots, {filled} filled',
      nodeStat: 'Nodes',
      slotStat: 'Slots',
      filledStat: 'With prompts',
      renderKeptStat: 'Render prompts kept',
      layerErrors: '⚠ Layer-4 validation failed ({count} issues): ',
      warnings: 'Warnings: ',
      unknownFiles: 'Unrecognized files: ',
      slotRatio: '{filled}/{total} slots',
      emptyModule: 'Empty',
      renderUploadButton: 'Upload Full Style Prompts',
      renderFileModalTitle: 'Style Prompt Files',
      renderUploadHint: 'Click or drag to upload style prompt files',
      renderPreviewModalTitle: 'Preview: Upload Full Style Prompts',
      renderUpdateSuccess:
        'Updated style prompts "{subject}": {filled} filled, {cleared} cleared',
      filledLabel: 'Filled',
      clearedLabel: 'Cleared',
      noSlotsToFill:
        '⚠ No slots to fill (no slot names match the current template). Check the .md format or upload the outline prompts first.',
      unmatchedSlots: 'Unmatched slots: ',
      filledClearedRatio: 'Filled {filled} / Cleared {cleared}',
      notMdSkipped: '{name} is not a .md file. Skipped',
      exceedsSizeSkipped: '{name} exceeds {size}MB. Skipped',
      duplicateSkipped: '{name} has already been uploaded',
      uploadFirst: 'Please upload at least one file first',
      parseFailed: 'Failed to parse. Please check the .md format',
      writeFailed: 'Failed to write. Please retry',
      parsePreview: 'Parse & Preview',
      backToEdit: 'Back to Edit',
      confirmOverwrite: 'Confirm Overwrite',
    },
    versions: {
      restoreSuccess: 'Version restored',
      restoreFailed: 'Failed to restore. Please retry',
      defaultTemplateName: '{version} template',
      nameRequired: 'Please enter a template name',
      savedAsTemplate: 'Saved as template',
      saveAsTemplateFailed: 'Failed to save as template. Please retry',
      versionColumn: 'Version',
      createdAtColumn: 'Created At',
      actionColumn: 'Actions',
      restore: 'Restore',
      savedAs: 'Saved',
      saveAsTemplate: 'Save as Template',
      emptyTitle: 'No versions yet',
      emptyHint: 'Click "Save Version" to save the current state',
      remarkLabel: 'Remark (optional)',
      namePlaceholder: 'Name this template',
      remarkPlaceholder: 'Briefly describe this template',
      sourceLine: 'Source: {tree} · {version}',
      currentCourseware: 'current courseware',
    },
    intro: {
      welcomeTitle: 'Welcome to TREE Content Tree Design',
      welcomeSubtitle:
        'Weave the structure of a lesson into a knowledge tree that grows, generates, and exports.',
      coreValuesTitle: 'Core Values',
      nodesSectionTitle: 'Six Node Types, Each with Its Role',
      stepsSectionTitle: 'Get Started in Four Steps',
      startButton: 'Get Started',
      origin: 'Origin',
      originDesc: 'The unique root node of the tree',
      reference: 'Reference',
      referenceDesc: 'Cross-node reference',
      moduleDesc: 'Main chapters',
      tagDesc: 'Knowledge point tags',
      slotDesc: 'Specific content units',
      transitionDesc: 'Stage transitions',
      structuredTitle: 'Structured Organization',
      structuredDesc:
        'Origin, Module, Tag, Slot, Transition, Reference — six node types keep courseware clearly layered and well related.',
      aiTitle: 'AI Generation',
      aiDesc:
        'Enter a course description and AI generates the full outline, or load a preset structure by subject in one click.',
      convertTitle: 'One-click Conversion',
      convertDesc:
        'Export a Markdown document, or auto-generate a complete editable courseware outline from the tree.',
      step1Title: 'Create the Origin',
      step1Desc: 'Click "+Origin" to create the single root node of the tree.',
      step2Title: 'Build Layer by Layer',
      step2Desc:
        'Select a node, then use "+Module / +Tag / +Slot..." to add child nodes by hierarchy rules.',
      step3Title: 'Generate Structure with AI',
      step3Desc:
        'Expand the TREE description, fill in course requirements, and generate the outline in one click.',
      step4Title: 'Export & Generate',
      step4Desc:
        'Save as a Markdown document, or generate the courseware content outline.',
    },
    unitPath: {
      label: 'Current unit: {path}',
    },
  },
  components: {
    resourceList: {
      theadInfo: 'Courseware Info',
      theadUpdatedAt: 'Updated At',
      theadUsage: 'Acquisitions',
      theadStatus: 'Status',
      theadOperation: 'Actions',
      mineBadge: 'Created by me',
      dateFormat: 'MMM D, YYYY',
      nameLabel: 'Name',
      introLabel: 'Introduction',
      nameRequired: 'Please enter a name',
      changeNameTitle: 'Edit Name',
      ok: 'OK',
      changeSuccess: 'Modified successfully',
      nameDuplicated: 'Name already exists',
      unitGuide: 'Unit Guide',
      thirdRowGuide: '{module} | Five-dimension Guide',
      thirdRowTopic: '{module} | {teachingCase} Topic',
      useSuccess: 'Acquired successfully',
      deleteTitle: 'Delete File',
      deleteReferencedWarning:
        'This file is used in published courseware; deleting it may affect subsequent updates',
      deleteConfirm: 'Are you sure you want to delete this file?',
      deleteSuccess: 'Deleted successfully',
      preview: 'Preview',
      use: 'Acquire',
      edit: 'Edit',
      permissionSetting: 'Permission Settings',
      delete: 'Delete',
      moreActions: 'More actions',
      scopePersonal: 'Private',
      scopeSchool: 'School Public',
      scopePlatform: 'Platform Public',
    },
    aiEvaluation: {
      scoreFormatted: '{score} pts',
      scoreMissing: 'Not scored',
      evaluating: 'Evaluating...',
      needsReconcile: 'Status Pending',
      needsReconcileTooltip:
        'The evaluation submission status is pending confirmation. Please contact the administrator for verification; do not submit again',
      reportButton: 'Evaluation Report',
      lastScore: 'Last evaluation: {score}',
      checkPassed: 'Basic check passed',
      checkFailed: 'Basic check failed',
      checkUnknown: 'Basic check result unknown',
      itemsDetail: 'Item details ({total} items, {failed} failed)',
      involvedFiles: 'Files involved: {files}',
      fileListSeparator: ', ',
      suggestionLabel: 'Suggestion: {suggestion}',
      reportTitle: 'AI Analysis Result',
      latestOnlyHint: '(Only the most recent evaluation report is shown)',
      noReport: 'No evaluation report yet',
      reconcileAlert:
        'The status of this evaluation is pending confirmation. Do not submit again; below is the result of the previous evaluation',
      evaluatingAlert:
        'This evaluation is still in progress; below is the result of the previous evaluation',
      coursewareNameLabel: 'Courseware Name',
      scoreLabel: 'Score: {score}',
      fullScore: 'Total: 100',
      verdictPass: 'Passed',
      verdictFail: 'Failed',
      fullReportAriaLabel:
        'View the full evaluation report (opens in a new tab)',
      viewFullReport: 'View Full Evaluation Report',
      failedReason: 'Failure Reason',
      summaryInfo: 'Summary',
      executionFailed: 'Evaluation task execution failed',
      noSummary: 'No summary was generated this time',
      completedTitle: 'Evaluation Completed',
      completedDescription:
        'This evaluation has been completed. You can view the evaluation report',
      viewResult: 'View Result',
      failedTitle: 'Evaluation Failed',
      failedFallback:
        'Evaluation task execution failed. You can submit it again',
      reconcileTitle: 'Evaluation Status Pending Confirmation',
      reconcileDescription:
        'The evaluation submission status cannot be confirmed. Please contact the administrator for verification; do not submit again',
      reusedTitle: 'An evaluation is already in progress for this courseware',
      submittedTitle: 'Evaluation Task Submitted',
      reusedDescription:
        'No duplicate submission was made. You can check the status in the evaluation report later',
      submittedDescription:
        'The evaluation is running in the background. You can view the result in the evaluation report later',
      gotIt: 'Got it',
      submitFailed: 'Failed to submit the evaluation task',
    },
    coursewareInfinite: {
      lastMonth: 'Last Month',
      lastThreeMonths: 'Last Three Months',
      older: 'Six Months and Older',
      ownerCreated: 'Modified',
      ownerUsed: 'Acquired',
      ownerCollaborated: 'Collaborated',
      usedTimeLabel: 'Acquired on: {date}',
      updatedTimeLabel: 'Last modified: {date}',
      releasedTimeLabel: 'Last published: {date}',
      iconAlt: 'Icon',
      unpublished: 'Unpublished',
      published: 'Published',
      coverAlt: 'Cover',
      menuPlay: 'Play',
      menuEditName: 'Rename',
      menuEditAudienceScope: 'Visibility Settings',
      menuDelete: 'Delete',
      deletePackageTitle: 'Delete Courseware Package',
      deletePackageConfirm:
        'Are you sure you want to delete this courseware package?',
      deleteSuccess: 'Deleted successfully',
      use: 'Acquire',
      originalCreator: 'Original creator · {name}',
      typeName: 'Courseware Package',
      tipTitle: 'Notice',
      acquiredPrefix:
        'You have successfully acquired the {type}. Please go to ',
      myAcquired: 'My Acquired',
      acquiredSuffix: ' list to view it.',
      view: 'View',
      nameDuplicated: 'Courseware name already exists',
      alreadyAcquiredConfirm:
        'You have already acquired this {type}. Continue?',
      useTitle: 'Acquire',
      copyDescription:
        'Copy this course to My {type}. After acquiring it, you can edit this {type} freely',
      typeNameLabel: '{type} Name',
      nameRequired: 'Please enter a name',
      ok: 'OK',
    },
    agentProcess: {
      htmlFile: 'HTML File',
      teachingPlan: 'Lesson Plan',
      guidedLearningPlan: 'Guided Learning Plan',
      verbatimScript: 'Lecture Script',
      knowledgeCard: 'Knowledge Card',
      interactiveWidget: 'Interactive Widget',
      answerAnalysis: 'Answer Analysis',
      pblStudyPlan: 'PBL Study Plan',
      evaluationForm: 'Evaluation Form',
      studentActivity: 'Student Activity',
      roleTask: 'Individual Role Task',
      summaryGuidance: 'Summary Guidance',
      testPaper: 'Test Paper',
      downloadWord: 'Download as Word',
      saveToMaterial: 'Save to Agent Material Library',
      saveMaterialSuccess: 'Saved to Agent Material Library successfully',
      fileAlreadyStored: 'File already stored',
      generating: 'File is being generated. Please try again later',
      copySuccess: 'Copied successfully',
      copyFailed: 'Copy failed',
      copyTooltip: 'Copy content',
      regenerate: 'Regenerate',
      notFinishedRetry:
        'Content is not fully generated yet. Please refresh and try again later',
      tabSearch: 'Search Results',
      tabPreview: 'File Preview',
      emptySearch: 'No search results',
      referenceLinks: 'References:',
      emptyPreview: 'No preview content',
      close: 'Close',
      selectSubjectFirst: 'Please select a subject in Smart Courseware first',
      downloadHtml: 'Download as HTML',
    },
    resourceCreation: {
      hintPptPdf: 'Only PPT and PDF are supported, up to 200MB',
      hintPpt: 'Only PPT is supported, up to 200MB',
      uploadIconAlt: 'Upload icon',
      clickOrDrag: 'Click / drag ',
      localFileHere: 'local files here',
      uploadSuccess: 'Uploaded successfully',
      unsupportedFormat: 'Unsupported file format',
      maxSizeExceeded: 'Uploaded file cannot exceed 200MB',
      uploadUrlMissing: 'Upload URL cannot be empty',
      uploadTokenFailed: 'Failed to get upload token',
      uploadFailed: '{name} upload failed',
      sceneLabel: 'Stage',
      stepLabel: 'Step',
      scaffoldLabel: 'Scaffold',
      fileRequired: 'Please select a file',
      modalTitleUpdate: 'Update {title} PPT Courseware',
      modalTitleCreate: 'Create {title} PPT Courseware',
      modalTitleUpload: 'Upload {title} PPT Courseware',
      nameDuplicated: 'Name already exists',
      changeSuccess: 'Modified successfully',
      footerUpdate: 'Update PPT Courseware',
      footerCreate: 'Create PPT Courseware',
      gradeLabel: 'Grade',
      textbookLabel: 'Textbook',
      textbookPlaceholder: 'Edition/Textbook/Unit',
      moduleLabel: 'Module',
      coursewareNameLabel: 'Courseware Name',
      coursewareNameRequired: 'Please enter the courseware name',
      coursewareNamePlaceholder: 'Please enter the courseware name',
      pleaseSelectField: 'Please select {text}',
    },
    coursewareLayout: {
      emptyUnitTitle:
        'No courseware created or uploaded by you in this unit yet',
      emptyUnitSubtitle:
        'Please upload/create courseware, or click any course category in the course list on the left to view resources',
      emptySectionTitle:
        'No courseware created or uploaded by you in this lesson yet',
      emptySectionSubtitle:
        'Please upload/create courseware, or acquire public courseware from the resource courseware below',
      updatedDateLabel: 'Updated',
      creatorLabel: 'Creator',
      schoolLabel: 'School',
      typeCourseware: 'Courseware',
      typeCoursewarePackage: 'Courseware Package',
      useCountLabel: 'References: {count}',
      get: 'Acquire',
      scopeBadgeAlt: 'Courseware visibility status',
      statusTagAlt: 'Status tag',
      renameSuccess: 'Renamed successfully',
      typeNameDuplicated: '{type} name already exists',
      inputNewNameTitle: 'Enter a new {type} name',
      cancel: 'Cancel',
      ok: 'OK',
      typeNameRequired: 'Please enter the {type} name',
      menuRename: 'Rename',
      menuEdit: 'Edit',
      menuDelete: 'Delete',
      menuMove: 'Move to',
      menuApplyUpload: 'Apply to Upload',
      menuPlay: 'Play',
      iconAlt: 'Icon',
      tipTitle: 'Notice',
      gotIt: 'Got it',
      pendingReviewNotice:
        'The {type} will be public after the school administrator approves it',
      deleteTypeTitle: 'Delete {type}',
      deleteTypeConfirm: 'Are you sure you want to delete this {type}?',
      deleteFailed: 'Delete failed',
      deleteSuccess: 'Deleted successfully',
    },
    coursewareCreation: {
      createSuccess: 'Created successfully',
      updateSuccess: 'Updated successfully',
      nameDuplicated: 'Courseware package name already exists',
      updateTitle: 'Update Courseware Package',
      createTitle: 'Create Courseware Package',
      structureLabel: 'Select Structure',
      structureRequired: 'Please select a structure',
      structureSssd: 'SSSD In-house Teaching Structure',
      structureFs: 'Free Structure',
      packageNameLabel: 'Courseware Package Name',
      packageNameRequired: 'Please enter the courseware package name',
      packageNamePlaceholder: 'Enter the courseware package name~',
      changeCover: 'Change Cover',
      coverLabel: 'Course Cover',
      selectFieldRequired: '{text}',
      selectGrade: 'Select Grade',
      selectTextbook: 'Select Textbook',
      imageAlt: 'Image',
      searchPlaceholder: 'Enter file name',
      officialTab: 'Official Materials',
    },
    profileTextbook: {
      switchHint: 'You can switch anytime from the top-left corner later',
      confirm: 'Confirm',
      gradePlaceholder: 'Grade',
      iconAlt: 'Icon',
      selectPrefix: 'Please select your ',
      gradeHighlight: 'teaching grade',
      and: ' and ',
      editionHighlight: 'textbook edition',
    },
    agentParams: {
      agreementLabel: 'I have read and agree to: {title}',
      agreementRequired: 'Please read and check this commitment',
      aiGenerate: 'AI Generate',
      duration45: '45 minutes',
      duration90: '90 minutes',
      durationLabel: 'Duration',
      durationPlaceholder: 'Select duration',
      gradeLabel: 'Grade',
      gradeRequired: 'Please select a grade!',
      gradePlaceholder: 'Select a grade',
      sectionLabel: 'Section',
      selectField: 'Select {label}',
      selectFieldWithBang: 'Please select {label}!',
      subjectLabel: 'Subject',
      subjectRequired: 'Please select a subject!',
      textbookUnitLabel: 'Edition/Textbook/Unit',
      textbookLabel: 'Edition/Textbook',
      noTextbook: 'No matching textbook',
      noTextbookTooltip:
        'Click this button if no matching textbook is in the options',
      textbookShortLabel: 'Textbook',
      textbookRequired: 'Please select a textbook!',
      unitShortLabel: 'Unit',
      unitRequired: 'Please select a unit!',
      unitPlaceholder: 'Select a unit',
      uploadPlanLabel: 'Upload Lesson Plan',
      uploadPlanRequired: 'Please upload a lesson plan!',
      usageAgreementTip:
        'By using this feature, you agree that content generated by this agent is for teaching reference only, and the teacher assumes responsibility for the political accuracy and compliance of the final content. You also agree not to use or distribute the generated content in non-teaching scenarios.',
      usageText: 'Usage Statement',
      uploadSuccess: 'Uploaded successfully',
      unsupportedType: 'Unsupported file type',
      maxSizeExceeded: 'Uploaded file cannot exceed {limit}MB',
      uploadFailed: '{name} upload failed',
      singleFileOnly: 'Only one file can be uploaded at a time',
      dropToUpload: 'Click or drag the file here to upload',
      wordLimitHint: 'Supports a single Word file, up to {limit} MB',
      uploading: 'Uploading…',
      delete: 'Delete',
    },
    resourceClassification: {
      iconAlt: 'Icon',
      title: 'Resource Categories',
    },
    coursewareInfo: {
      iconAlt: 'Icon',
      title: 'Courseware Info',
      introTitle: 'Courseware Introduction',
      nameLabel: 'Courseware Name',
      introLabel: 'Courseware Introduction',
      textbookLabel: 'Textbook',
      publishTitle: 'Current Release',
      idLabel: 'Courseware ID',
      versionLabel: 'Version',
      releasedAtLabel: 'Release Time',
      ownerLabel: 'Owner',
      useCountLabel: 'Acquisitions',
      viewCountLabel: 'Views',
    },
    operateDropdown: {
      iconAlt: 'Icon',
      preview: 'Preview',
      play: 'Play',
      use: 'Acquire',
      editFile: 'Edit File',
      edit: 'Edit',
      setting: 'Settings',
      detail: 'Details',
      delete: 'Delete',
      remove: 'Remove',
    },
    coursewareInfoPopover: {
      infoTitle: 'Courseware Info',
      packageTitle: 'Courseware Package Info',
      packageName: 'Courseware Package',
      updatedAtLabel: 'Last modified: ',
      releasedAtLabel: 'Last published: ',
      schoolLabel: 'School: ',
      idLabel: 'ID: ',
    },
    loading: {
      loadingText: 'Loading, please wait…',
      reloadPrefix:
        'Please wait. If the PPT preview does not appear for a long time, ',
      reloadPage: 'refresh the page',
    },
    emptyShare: {
      emptyAlt: 'No data',
      defaultText:
        'No resources yet. Stay tuned for shares from other teachers',
    },
    emptyState: {
      emptyAlt: 'Empty state',
    },
    listNavigation: {
      iconAlt: 'Icon',
    },
    settingVisible: {
      setSuccess: 'Settings saved',
      setFailed: 'Failed to save settings',
      publishTitle: 'Publish Courseware',
      settingTitle: 'Settings',
      publishHint:
        'Publish the current courseware version. Please choose whether the courseware is public when publishing.',
      notSchoolToast:
        'You have not joined a school yet, so it cannot be made public to the school',
      notOwnerToast: 'You cannot modify courseware shared with you by others',
      creatingDisabledHint: 'Permissions opened at creation cannot be changed',
    },
    applyRelease: {
      scopeTitle: 'Set Visibility Scope',
      scopeSchool: 'School public (visible only within your school)',
      scopePlatform:
        'Platform public (visible across the whole platform, including your school)',
    },
    teachingScaffoldIcon: {
      iconAlt: 'Icon',
    },
    coursewareBadge: {
      canEdit: 'Editable',
      canView: 'View only',
      createdByMe: 'Created by me',
    },
    coursewareHeader: {
      tabAll: 'All',
      tabSchool: 'School Public',
      tabPlatform: 'Platform Public',
    },
    goToCommunityButton: {
      ariaLabel: 'Go to the Resource Square for inspiration',
    },
    gradeSelect: {
      placeholder: 'Grade',
    },
    subjectSelect: {
      placeholder: 'Select a subject',
    },
    scopeSelect: {
      school: 'School Public',
      platform: 'Platform Public',
      placeholder: 'Visibility Scope',
    },
    publishStatusSelect: {
      published: 'Published',
      unpublished: 'Unpublished',
      placeholder: 'Publish Status',
    },
    unitSelect: {
      placeholder: 'Select a unit',
    },
    unitCascader: {
      placeholder: 'Unit/Section',
    },
    textbookSelect: {
      placeholder: 'Select a textbook',
    },
    textbookCascader: {
      placeholder: 'Edition/Textbook',
      placeholderWithUnit: 'Edition/Textbook/Unit',
    },
    subjectCascader: {
      placeholder: 'Subject/Grade',
    },
    teachingCaseSelect: {
      placeholder: 'Case Level',
    },
    stepSelect: {
      placeholder: 'Step',
    },
    sectionSelect: {
      placeholder: 'Select a section',
    },
    scaffoldSelect: {
      placeholder: 'Scaffold',
    },
    moduleSelect: {
      placeholder: 'Module',
    },
    editionSelect: {
      placeholder: 'Select an edition',
    },
    coursewareFilter: {
      searchPlaceholder: 'Search by courseware package name',
    },
    settingModal: {
      title: 'Courseware Package Settings',
      goPublish: 'Publish',
      unpublishedHint:
        'This courseware package is unpublished and cannot be configured!',
    },
  },
  myStudents: {
    identityNotFoundTitle: 'Teacher Identity Not Activated',
    identityNotFoundDesc:
      'Student management is not activated for this account. Please contact your school administrator to add a teacher identity.',
    loadFailed: 'Failed to load. Please refresh and try again',
    panelTitle: 'My Students',
    panelSubtitle: 'Group Management · Personal Tags',
    groupLimitTooltip: 'Group limit reached (max {limit})',
    createGroup: 'New Group',
    renameGroup: 'Rename Group',
    groupNamePlaceholder: 'Enter a group name (max 10 characters)',
    groupNameOverLimit: 'Group name cannot exceed {max} characters',
    deleteGroupTitle: 'Delete this group?',
    deleteGroupWithStudents:
      'This group has {count} students. Only the group will be deleted, not the students. You can find them under "All Students" and regroup them.',
    deleteGroupNoRestore: 'This action cannot be undone',
    allStudents: 'All Students',
    studentCount: '{total} Students',
    addStudent: 'Add Student',
    addStudentMember: 'Add Student Members',
    searchPlaceholder: 'Search by student name/ID',
    emptyGroup: 'No students in this group yet. Add some!',
    bindStudentTitle: 'Bind New Student',
    bindStudentPlaceholder: 'Enter a student ID to search',
    addMembersTitle: 'Add Student Members ({group})',
    transferJoined: 'Joined',
    transferJoin: 'Add',
    transferRemove: 'Remove',
    itemUnit: 'student',
    itemsUnit: 'students',
    transferNotFound: 'No students',
    transferSearchPlaceholder: 'Name / Student ID',
    tagManageTitle: 'Manage Tags',
    studentLabel: 'Student: {name}',
    tagNamePlaceholder: 'Enter a tag name',
    tagNameOverLimit: 'Tag name cannot exceed {max} characters',
    tagLimitReached:
      'Tag limit reached. Please adjust existing tags before adding more',
    existingTags: 'Existing Tags',
    removed: 'Removed',
    remove: 'Remove',
    removeConfirmTitle: 'Remove',
    removeConfirmContent: 'Remove this student from the current group?',
    tagsLabel: 'Tags:',
    groupsLabel: 'Groups:',
    add: 'Add',
    noTags: 'No tags',
    ungrouped: 'Ungrouped',
    ok: 'OK',
    cancel: 'Cancel',
    rename: 'Rename',
    deleteGroup: 'Delete Group',
    moreActions: 'More actions',
    deleteTagAria: 'Delete tag',
  },
};
